/**
 * Protocol limits and rates (docs/43 §3, §7; 92 A13).
 * The client's own fixed-step rate is `CLIENT_SIM_HZ` in `iso.js`; the two
 * rates are independent (98 Q-01).
 */
import { MAX_PATH_TILES } from '../net/path';
/** Server patch rate (Colyseus `patchRate`). */
export const SERVER_TICK_HZ = 10;
export const SERVER_PATCH_MS = 1000 / SERVER_TICK_HZ; // 100
/** Max players per area instance; 42 is the soft cap for new joins (98 Q-42). */
export const AREA_MAX_CLIENTS = 50;
export const AREA_SOFT_CAP = 42;
/** Max players in a home instance. */
export const HOME_MAX_CLIENTS = 8;
/** Colyseus disconnects a client above this (43 §1). */
export const MAX_MESSAGES_PER_SECOND = 30;
/** Say text cap after trim, in UTF-16 units (43 §3.6, 92 A13). */
export const SAY_MAX_CHARS = 140;
/** Say delivery radius in tiles, Chebyshev distance (43 §3.6; far clients get nothing, 98 Q-26). */
export const HEAR_RADIUS = 12;
/** Max ops in one BuildOps request (43 §3.8). */
export const BUILD_OPS_PER_REQ = 20;
/** Display-name cap. */
export const NAME_MAX_CHARS = 20;
export { MAX_PATH_TILES };
/** Keyed by message name; the room maps C2S ids to these (43 §3, 92 A13). */
export const RATE_LIMITS = {
    Ping: { burst: 4, perSec: 2 },
    Presence: { burst: 4, perSec: 2 },
    Move: { burst: 8, perSec: 5 },
    Stop: { burst: 8, perSec: 5 },
    Interact: { burst: 5, perSec: 3 },
    InteractCancel: { burst: 5, perSec: 3 },
    Say: { burst: 3, perSec: 1 / 1.5 },
    Emote: { burst: 2, perSec: 1 },
    Travel: { burst: 1, perSec: 1 / 3 },
    VoiceJoin: { burst: 2, perSec: 0.2 },
    VoiceTalk: { burst: 4, perSec: 10 },
    BuildOps: { burst: 20, perSec: 10 },
    Knock: { burst: 1, perSec: 0.2 },
    KnockAnswer: { burst: 2, perSec: 1 },
    Akara: { burst: 10, perSec: 5 },
};
